import React from 'react';

export default class About extends React.Component {
    render() {
        return (
            <div className="About">
                <h1>What is this page?</h1>

                <p>
                    This is a Dimensions details page, which tells you about the citations that have been identified for
                    a publication. Several metrics to help you understand the scholarly impact of the publication:
                </p>

                <ul>
                    <li>Total citations</li>
                    <li>Recent citations</li>
                    <li>Relative Citation Ratio (RCR)</li>
                    <li>Field Citation Ratio (FCR)</li>
                </ul>

                <p>
                    You can use the Dimensions details page to find out which works that have cited this particular
                    publication - this information is available in the “Citations tab”. You can also go to the “Citing
                    research categories” tab to see the research categories (subject areas) of the citing publications.
                </p>

                <h1>Where can I find out more?</h1>

                <p>
                    Please visit our{' '}
                    <a href="https://support.dimensions.ai/support/home" rel="noopener noreferrer" target="_blank">
                        Support Center
                    </a>{' '}
                    to read more about Dimensions or email us at{' '}
                    <a href="mailto: support@dimensions.ai">support@dimensions.ai</a>.
                </p>
            </div>
        );
    }
}
